import * as XLSX from 'xlsx'
import type { Case } from '../types'

export async function exportCasesToExcel(cases: Case[], options?: {
  includeDocuments?: boolean
  includeNodes?: boolean
}): Promise<Blob> {
  const wb = XLSX.utils.book_new()

  // Sheet 1: 案件基本信息
  const caseData = cases.map(c => ({
    '案号': c.case_number || '',
    '案由': c.title,
    '案件类型': c.case_type === 'civil_litigation' ? '民事诉讼' : c.case_type === 'trademark_admin' ? '商标行政诉讼' : '其他',
    '我方角色': c.party_role === 'plaintiff' ? '原告' : c.party_role === 'defendant' ? '被告' : '第三人',
    '对方当事人': c.opposing_party,
    '法院': c.court || '',
    '标的金额': c.claim_amount || '',
    '立案日期': c.filing_date || '',
    '案件状态': c.status === 'active' ? '进行中' : c.status === 'closed' ? '已结案' : c.status === 'suspended' ? '中止' : '待发起',
  }))

  const ws = XLSX.utils.json_to_sheet(caseData)
  XLSX.utils.book_append_sheet(wb, ws, '案件信息')

  if (options?.includeDocuments) {
    // Sheet 2: 文书清单（需要额外数据）
    const docWs = XLSX.utils.json_to_sheet([])
    XLSX.utils.book_append_sheet(wb, docWs, '文书清单')
  }

  if (options?.includeNodes) {
    // Sheet 3: 程序节点（需要额外数据）
    const nodeWs = XLSX.utils.json_to_sheet([])
    XLSX.utils.book_append_sheet(wb, nodeWs, '程序节点')
  }

  return new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
}
